// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid rgb(225, 228, 231);
  }
`

type Props = {
  children?: any,
  style?: Object
}

const Table = ({ children, style }: Props) => (
  <Component style={style}>{children}</Component>
)

export default Table



// WEBPACK FOOTER //
// ./src/components/Tr/index.js